'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toIdArray = exports.getMany = exports.propFrom = exports.propIn = exports.prop = undefined;

var _fp = require('lodash/fp');

/**
 * Retrieves a property from an object.  The object can be a POJO or an Immutable object.
 */
var prop = exports.prop = (0, _fp.curry)(function (propName, object) {
    if (!object) return object;

    return (0, _fp.isFunction)(object.get) ? object.get(propName) : object[propName];
}); // Lib
var propIn = exports.propIn = (0, _fp.curry)(function (propArray, object) {
    if (!object) return object;

    return (0, _fp.isFunction)(object.getIn) ? object.getIn(propArray) : (0, _fp.get)(propArray, object);
});

/**
 * Same as prop but takes the arguments in the reverse order.
 */
var propFrom = exports.propFrom = (0, _fp.curryN)(2, (0, _fp.flip)(prop));

var getMany = exports.getMany = function getMany(keys, map) {
    return map.filter(function (object, key) {
        return (0, _fp.includes)(key, keys);
    });
};

var toIdArray = exports.toIdArray = function toIdArray(immutableMap) {
    return immutableMap.keySeq().toArray();
};


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/immutableHelper.js
// module id = 23
// module chunks = 0